import { Tag } from '../Tag';
import { WarrantyTagProps } from './WarrantyTag.typed';

function WarrantyTag(props: WarrantyTagProps) {
  const { text = 'Warranty' } = props;
  return <Tag text={text} textColor="GREY_DARK" bgColor="GREY_LIGHTER" />;
}

export { WarrantyTag };
